import React, { HTMLProps } from 'react';

import { InputRadioSyle } from './styles';

const RadioFieldNew = ({ children, ...rest }) => {
  return (
    <InputRadioSyle>
      <input type="radio" {...rest} />
      {children && <label htmlFor={rest.id}>{children}</label>}
    </InputRadioSyle>
  );
};

export default RadioFieldNew;
